export default "__VITE_ASSET__CvHsGOHM__"